// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as _ from "lodash";
import * as React from "react";
import { ApplicationList, ApplicationListItem } from "../../../components/ApplicationList";
import { privateApi } from "../../../api";
import { jsx as _jsx } from "react/jsx-runtime";
export const DashboardWidgetList = props => {
  const {
    onSelectionChange
  } = props;
  const [widgets, setWidgets] = React.useState([]);
  const [active, setActive] = React.useState();
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    setLoading(true);
    privateApi.get("/api/v1/utilisateurs/dashboards/widgets").then(value => {
      setWidgets(value);
    }).finally(() => {
      setLoading(false);
    });
  }, []);
  React.useEffect(() => {
    onSelectionChange?.({
      identifiant: active
    });
  }, [active, onSelectionChange]);
  const handleClick = React.useCallback(identifiant => () => setActive(identifiant), []);
  return /*#__PURE__*/_jsx(ApplicationList, {
    loading: loading,
    divided: true,
    "data-sentry-element": "ApplicationList",
    "data-sentry-component": "DashboardWidgetList",
    "data-sentry-source-file": "DashboardWidgetList.tsx",
    children: _.map(widgets, widget => /*#__PURE__*/_jsx(ApplicationListItem, {
      content: widget.nom,
      description: widget.description,
      onClick: handleClick(widget.identifiant),
      selected: active === widget.identifiant
    }, widget.identifiant))
  });
};
export default DashboardWidgetList;